/// <amd-module name="SuiteCommerce.Blog.PostCardsCCT.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.PostCardsCCT.View", ["require", "exports", "sc_post_cards_cct_template.tpl", "CustomContentType.Base.View", "SuiteCommerce.Blog.PostCardsCCT.Model", "SuiteCommerce.Blog.PostCard.View", "SuiteCommerce.Blog.PostList.View", "SuiteCommerce.Blog.PostList.Model", "SuiteCommerce.Blog.Common.Searcher.Helper", "SuiteCommerce.Blog.Post.Collection"], function (require, exports, postCCTTemplate, CustomContentTypeBaseView, PostCardsCCT_Model_1, PostCard_View_1, PostList_View_1, PostList_Model_1, BlogPostSearcher_Helper_1, Post_Collection_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PostCardsCCTView = void 0;
    var PostCardsCCTView = /** @class */ (function (_super) {
        __extends(PostCardsCCTView, _super);
        function PostCardsCCTView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = postCCTTemplate;
            _this.model = new PostCardsCCT_Model_1.PostCardsCCTModel();
            _this.postListModel = new PostList_Model_1.PostListModel({
                postCardLayout: _this.model.useVerticalLayout
                    ? PostCard_View_1.PostCardLayout.vertical
                    : PostCard_View_1.PostCardLayout.horizontal,
                posts: _this.model.posts,
                showPostCardsPlaceholders: false,
                postCardPlaceholdersQuantity: 0,
            });
            _this.postListView = new PostList_View_1.PostListView({ model: _this.postListModel });
            _this.setupListener();
            return _this;
        }
        PostCardsCCTView.prototype.setupListener = function () {
            var _this = this;
            this.postListModel.on('postListUpdated', function () {
                _this.model.posts
                    .fetch(BlogPostSearcher_Helper_1.BlogPostSearcherHelper.buildRequestBody(_this.model.getBlogPostSearcherOptions()))
                    .done(function () {
                    _this.postListModel.posts = new Post_Collection_1.PostCollection(_this.model.posts.slice(0, _this.model.postQuantity));
                    _this.postListModel.showPostCardsPlaceholders = false;
                    _this.render();
                });
            });
        };
        PostCardsCCTView.prototype.install = function (settings, contextData) {
            _super.prototype.install.call(this, settings, contextData);
            this.updateModels(settings);
            return jQuery.Deferred().resolve();
        };
        PostCardsCCTView.prototype.update = function (settings) {
            _super.prototype.update.call(this, settings);
            this.updateModels(settings);
            return jQuery.Deferred().resolve();
        };
        PostCardsCCTView.prototype.updateModels = function (settings) {
            this.model.set(settings);
            this.postListModel.set({
                postCardLayout: this.model.useVerticalLayout
                    ? PostCard_View_1.PostCardLayout.vertical
                    : PostCard_View_1.PostCardLayout.horizontal,
                posts: this.model.posts,
                showPostCardsPlaceholders: true,
                postCardPlaceholdersQuantity: this.model.postQuantity,
            });
            this.postListModel.trigger('postListUpdated');
        };
        Object.defineProperty(PostCardsCCTView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'PostList.View': function () {
                        return _this.postListView;
                    },
                };
            },
            enumerable: false,
            configurable: true
        });
        PostCardsCCTView.prototype.validateContextDataRequest = function () {
            return true;
        };
        PostCardsCCTView.prototype.getContext = function () {
            if (this.model.posts.length > 0) {
                return {
                    cctHeading: this.model.cctTitle,
                };
            }
            return;
        };
        return PostCardsCCTView;
    }(CustomContentTypeBaseView));
    exports.PostCardsCCTView = PostCardsCCTView;
});
